import * as CoreSagas from '@ec-oem/ec.oem.oa3.ui.core/sagas';
import * as CommonSagas from '@ec-oem/ec.oem.oa3.ui.common/sagas';
import * as Sagas from '../sagas';
import * as ActivationSagas from '../../Activation/sagas';

const sagas = { ...CoreSagas, ...CommonSagas, ...Sagas,...ActivationSagas };

export const initSagas = (sagaMiddleware) => {
    Object.values(sagas).forEach(sagaMiddleware.run.bind(sagaMiddleware));
}